import { useEffect, useContext } from 'react';
import { TermType, TermItem } from '../types';
import { TermsData } from '../data';
import { TermsContext } from '../components/SectionTerms/SectionTerms';

export const useSearchTerm = () => {
  const { searchValue, setSearchValue, isSearchActive, setIsSearchActive, foundTerms, setFoundTerms } = useContext(TermsContext);

  const searchTerm = (sourceArray: TermType[], searchValue: string) => {
    let result: any = [];

    if (searchValue === '') {
      result = [];
      return result;
    }

    sourceArray.forEach((item: TermType) => {
      if (!item.terms.length) return;
      item.terms.forEach((term: TermItem) => {
        if (term.name.toLowerCase().includes(searchValue.toLowerCase())) {
          result.push(term);
        }
      });
    });

    return result.length > 0 ? result : [];
  };

  useEffect(() => {
    if (isSearchActive) {
      const result: TermItem[] = searchTerm(TermsData, searchValue);
      setFoundTerms(result);
    }
  }, [searchValue, isSearchActive]);

  return {
    searchValue,
    setSearchValue,
    isSearchActive,
    setIsSearchActive,
    foundTerms,
  };
};